<app-modal
  [isOpen]="isOpen"
  [title]="options?.title || 'Confirmação'"
  [size]="'sm'"
  [closable]="true"
  (close)="onClose()">
  
  <div class="confirmation-content">
    <div class="confirmation-icon" [ngClass]="getHeaderClass()">
      <i [ngClass]="getIconClass()"></i>
    </div>
    
    <div class="confirmation-message">
      <p>{{ options?.message || '' }}</p>
    </div>
  </div>

  <div slot="footer" class="confirmation-footer">
    <button
      *ngIf="!options?.hideCancelButton"
      type="button"
      class="btn"
      [ngClass]="options?.cancelButtonClass || 'btn-secondary'"
      (click)="onCancel()">
      <i class="fas fa-times"></i>
      {{ options?.cancelText || 'Cancelar' }}
    </button>
    
    <button
      type="button"
      class="btn"
      [ngClass]="options?.confirmButtonClass || 'btn-primary'"
      (click)="onConfirm()">
      <i class="fas fa-check"></i>
      {{ options?.confirmText || 'Confirmar' }}
    </button>
  </div>
</app-modal>
